import { status } from '../../helpers'

const getInventoryStoreDefaultState = () => {
  return {
    loadingProductInventory: status.INITIALIZED,
    productInventoryList: [],
    loadingStoreInventory: status.INITIALIZED,
    storeInventoryList: [],
    togglinProductVisibility: status.INITIALIZED,
    isReplenishProducts: false,
    updatingProduct: status.INITIALIZED,
    totalCount: 0,
    storeTotalCount: 0,
    requestEstimateCount: 0,
    stockThresholdValue: 0
  }
}

export default getInventoryStoreDefaultState
